import sideBorder from '../images/sidebarOff.svg';
import sideBorderLight from '../images/sideLight.svg';
import sideMenuLight from '../images/sideMenuLight.svg';
import sideMenuDark from '../images/sideMenu.svg';
import tableLink from '../images/tableLink.svg';
import tableLinkDark from '../images/tableLinkDark.svg';
import userDiv from '../images/userDiv.svg';
import BgImage from '../images/backbg.png';
import BgImage2 from '../images/backbg2.png';
import UPLogoIcon from '../images/up-logo.svg';
import UPLogoIcon2 from '../images/up-logo2.svg';
import userDivLight from '../images/userDivLight.svg';

export default {
  light: {
    overrides: {
      MuiTooltip: {
        tooltip: {
          backgroundColor: '#000 !important',
        },
      },
    },
    menu: 250,
    logo: 0,
    abcd: 0,
    palette: {
      type: 'light',
      primary: {
        contrastText: '#fafafa',
        dark: '#ebebeb',
        light: '#f3f3f3',
        bg: '#fafafa',
        main: '#c4c4c4',
        popup: '#a6a6a6',
        botBorderColor: '#D5D5D5',
        searchBorder: 'rgba(0,0,0,0.42)',
        lightCol: '#696969',
        TextCol: '#9A9A9A',
        dropCol: '#000000',
        borderCol: ' 1px solid #E2E2E2',
        bottomDiv: 'radial-gradient(50% 50% at 42% 50%, #CBCBCB 0%, #FFFFFF 100%)',
        imgCol: '#FAFAFA',
        imgBor: ' 1px solid #E8E8E8',
        bg2: '#fff',
        bg3: '#f3f3f3',
        bg4: '#e5e5e5',
      },
      formPage: {
        backgroundImage: `url(${BgImage2}) 12% 20%`,
        backgroundColor: '#fff',
        pamBackgroundColor: '#EC2323',
        esBackgroundColor: '#0165F7',
        dtBackgroundColor: '#F5BE10',
        shadowbox: '0px 0px 20px 10px rgb(0 0 0 / 10%)',
        epsBackgroundColor: '#0BE00A',
        satBackgroundColor: '#D300FF',
        ztnBackgroundColor: '#6ABDC3',
        sfsBackgroundColor: '#701ce1',
        avBackgroundColor: '#0BE00A',
        cipBackgroundColor: '#3865B7',
        cardBackgroundColor: '#fff',
        backgroundColorInput: '#fff',
        fieldShadow: '0px 0px 20px 4px rgb(0 0 0 / 9%)',
        blockShadow: '0px 0px 17px 5px rgb(0 0 0 / 7%)',
        stepFormShadow: '0px 0px 0px 8px rgb(0 0 0 / 12%)',
        stepFormBackgroundColor: 'white',
        textAreaShadow: 'none',
        prevBorderColor: '#0aaf58',
        prevBorderWidth: '2px',
        color: '#111!important',
        textColor: '#111',
        titleTextColor: '#111',
        logo: `url(${UPLogoIcon2})`,
        filter: 'invert(1)',
        modalHeaderBg: '#f3f3f3',
        modalContentBg: '#FFF !important',
        modalCol: '#000',
        modalFailCol: '#ff0202',
        modalFailColBorder: '1px solid #ff0202',
      },

      inputBackgroundColor: {
        backgroundColor: '#d0d0d0',
      },
      loaderPrimary: {
        color: '#ebebeb',
      },
      loaderSecondary: {
        color: '#f3f3f3',
      },
      secondary: {
        contrastText: '#1c1c1c',
        dark: '#161616',
        light: '#e0e0e0',
        main: '#161616',
        bgSet: '#ECECEC',
        borderSet: '#DEDEDE',
        svgCol: '#575757',
        borderColors: '#E4E4E4',
      },
      background: {
        default: '#fafafa',
        paper: '#fff',
      },
      modalTextColorS: {
        color: '#8D8D8D',
      },
      sidebarBackground: {
        color: '#fff',
      },
      colorSet: {
        color: 'black',
        background: '#ECECEC',
      },
      showTextC: {
        color: '#000',
        background: '#F9F9F9',
        border: '1px solid #EBEBEB',
      },
      sideLinkCol: {
        background: '#ECECEC',
      },
      sideMenuI: {
        background: `url(${sideMenuLight})`,
      },
      sideLinkActive: {
        background: '#fff',
      },
      searchBar: {
        background: '#fff',
        boxShadow: '0px 0px 0px 2.5px rgba(0, 0, 0, 0.08)',

      },
      formInp: { background: '#f4f4f4!important' },
      tdCol: {
        background: '#f3f3f3',
        color: 'black!important',
      },
      borderC: {
        color: '#d0d0d0',
      },
      childBtn: {
        color: '#DEDEDE',
        background: 'white',

      },
      btnSvg: {
        color: '#4D4D4D',
      },
      iconsSet: {
        background: `url(${sideBorderLight})`,
      },
      sideLinkImg: {
        background: '#ECECEC',
      },
      sideLinkBottom: {
        background: 'radial-gradient(50% 50% at 50% 50%, #dbd1d1 0%, rgba(138, 138, 138, 0) 100%)',
      },
      modalTextColor: {
        color: '#000',
        background: '#fff',
        bgSet: '#EBEBEB',
        filter: 'invert(1)',
        MainCol: '#fff',
        borderColor: '#E1E1E1',
      },
      login: {
        background: {
          backgroundColor: '#e5e5e5',
          // eslint-disable-next-line global-require
          backgroundImage: `url(${require('../images/bg.png').default})`,
        },
        iconColorPrimary: '#139a53',
      },
      contentBackground: {
        color: '#ededed',
      },
      disableOpacity: {
        opacity: 0.2,
      },
      actionBtnBorder: {
        color: '#c4c4c4',
        colorS: '#c4c4c4',
        background: '#EBEBEB',
        border: 'none',
        bili: '#000',
        colorBorder: 'initial',
      },
      actionBtnBorderCol: {
        color: 'none',
        border: '1px solid #C2C2C2',
      },
      tableBg: {
        color: '#fff',
        boxShadow: ' 6px 6px 55px rgba(0, 0, 0, 0.04)',
      },
      tableDis: {
        color: '#999797',
      },
      iconLabelBg: {
        color: '#a6a6a6',
      },
      iconLabelBgDisabled: {
        color: '#fafafa',
      },
      iconLabelTextDisabled: {
        color: '#000;',
      },
      profileEditBg: {
        color: '#ffffff',
      },
      profileSectionSidebar: {
        color: '#ebebeb',
      },
      profileSectionSidebarContent: {
        color: '#fff',
      },
      backArrowBtn: {
        color: '#fff',
      },
      headerBgColor: {
        color: '#fff',
      },
      sidebarBtn: {
        color: '#E0E0E0',
      },
      mainLayout: {
        color: '#F2F2F2',
      },
      mainTableLayoutBg: {
        color: '#fff',
      },
      mainTableBorder: {
        color: '#ebebeb',
      },
      tableBorderTransparent: {
        bgColour: '#FFF',
        color: '#DEDEDE',
      },
      modalsContentBg: {
        color: '#fff',
        backgroundImage: `url(${userDiv})`,
      },
      activeButton: {
        color: '#242A30',
      },
      headerIcons: {
        color: '#f9f9f9',
      },
      platform: {
        color: '#fff',
      },
      counterBorder: {
        color: '#dadee4',
      },
      modalHeaderBg: {
        color: '#161616',
      },
      mainTableLayout: {
        color: '#fff',
      },
      avatarBg: {
        color: '#ddd',
      },
      sidebarIconBg: {
        color: '#494962',
      },
      activeDropdown: {
        color: '#c4c4c4',
      },
      activeDropdownButton: {
        color: '#afafaf',
      },
      dropdownHover: {
        color: 'rgba(255, 255, 255, 0.04)',
      },
      headerBorder: {
        color: 'rgba(163,163,175,.35)',
      },
      sidebarBg: {
        background: '#fff',
      },
      activeMenuBg: {
        color: 'rgba(37,39,53,.1)',
      },
      borderDark: {
        color: '#dedede',
      },
      tableTbodyBg: {
        color: '#fff',
        background: `url(${tableLinkDark})`,
      },
      defaultBtnShadow: {
        boxShadow: '0 0 10px rgb(0 0 0 / 10%), 0 0 5px rgb(0 0 0 / 10%)',
        background: '#A0A0A0',
        color: '#F5F5F5',
        borderColor: '#DCDCDC',
        filter: 'invert(1)',
        backgroundHover: '#818181',

      },
      invert: {
        invert: 'unset',
      },
      profileLogo: {
        color: '#eee',
      },
    },
  },

  dark: {
    overrides: {
      MuiTooltip: {
        tooltip: {
          backgroundColor: '#000 !important',
        },
      },
    },
    menu: 250,
    logo: 1,
    palette: {
      type: 'dark',
      formPage: {
        backgroundImage: `url(${BgImage}) 12% 20%`,
        backgroundColor: '#222538',
        pamBackgroundColor: '#2F324A',
        esBackgroundColor: '#2F324A',
        dtBackgroundColor: '#2F324A',
        epsBackgroundColor: '#2F324A',
        satBackgroundColor: '#2F324A',
        ztnBackgroundColor: '#2F324A',
        sfsBackgroundColor: '#2F324A',
        avBackgroundColor: '#2F324A',
        cipBackgroundColor: '#2F324A',
        cardBackgroundColor: '#292C41',
        shadowbox: '5px 5px 20px 6px rgb(0 0 0 / 18%)',
        backgroundColorInput: '#2F3246',
        fieldShadow: '0px 12px 12px rgb(0 0 0 / 15%)',
        blockShadow: '0px 12px 12px rgb(0 0 0 / 15%)',
        stepFormShadow: '0px 0px 0px 8px rgb(0 0 0 / 33%)',
        stepFormBackgroundColor: '#ccc',
        textAreaShadow: '0px 12px 12px rgba(0, 0, 0, 0.08)',
        prevBorderColor: '#fff',
        prevBorderWidth: '1px',
        color: '#fff!important',
        textColor: '#dbdbdb',
        titleTextColor: '#83869b',
        logo: `url(${UPLogoIcon})`,
        filter: 'unset',
        modalHeaderBg: '#343950',
        modalContentBg: '#2C3148 !important',
        modalCol: '#fff',
        modalFailCol: '#f94141',
        modalFailColBorder: '1px solid #f94141',
      },
      primary: {
        contrastText: '#fafafa',
        dark: '#191919',
        light: '#454545',
        main: '#1f1d2b',
        bg: '#323445',
        botBorderColor: '#444A76',
        popup: '#454545',
        searchBorder: 'rgba(255,255,255,0.7)',
        lightCol: '#CFCFCF',
        TextCol: '#CFCFCF',
        dropCol: '#CFCFCF',
        borderCol: ' 1px solid #404253',
        bottomDiv: 'radial-gradient(50% 50% at 42% 50%, #4B4E66 0%, #1D1E28 100%)',
        imgBor: ' 1px solid #3E4259',
        bg2: '#282B3E',
        bg3: '#24283D',
        bg4: '#1E2032',
      },
      login: {
        background: {
          backgroundColor: '#252935',
          // eslint-disable-next-line global-require
          backgroundImage: `url(${require('../images/bg.png').default})`,
        },
        iconColorPrimary: '#fff',
      },
      sideMenuI: {
        background: `url(${sideMenuDark})`,
      },
      formInp: { background: '#202232!important' },
      iconsSet: {
        background: `url(${sideBorder})`,
      },
      secondary: {
        contrastText: '#fff',
        dark: '#292929',
        bgSet: '#1f1d2b',
        borderSet: '#686E93',
        light: '#454545',
        main: '#292929',
        svgCol: '#ffffffde',
        borderColors: '#a3a3af59',
      },
      inputBackgroundColor: {
        backgroundColor: 'rgb(57, 60, 71)',
        mozBackgroundColor: 'rgb(57, 60, 71, 0)',
      },
      tdCol: {
        background: '#282B3E',
        color: 'white!important',
      },
      childBtn: {
        color: '#fff',
        background: 'none',
      },
      btnSvg: {
        color: 'white',
      },
      colorSet: {
        color: 'white',
        background: '#1E202C',
      },
      sideLinkCol: {
        background: '#191A25',
      },
      sideLinkActive: {
        background: '#191A25',
      },
      searchBar: {
        background: '#131523',
        boxShadow: '0px 0px 0px 1.5px rgb(255 255 255 / 3%)',
      },
      sideLinkBottom: {
        background: 'radial-gradient(50% 50% at 50% 50%, #4B4E66 0%, rgba(71, 75, 101, 0) 100%)',
      },
      background: {
        default: '#191919',
        paper: '#2a2c39',
      },
      borderC: {
        color: '#434667',
      },
      modalTextColor: {
        color: '#fff',
        background: '#0b0c11',
        bgSet: '#2A2D3F',
        filter: 'none',
        MainCol: '#212331',
        borderColor: '#2A2D3F',
      },
      modalTextColorS: {
        color: '#FFFFFF',
      },
      sidebarBackground: {
        color: '#1d1e28',
      },
      contentBackground: {
        color: '#3a3a3a',
      },
      disableOpacity: {
        opacity: 0.5,
      },
      showTextC: {
        color: '#02B959',
        background: 'none',
        border: '1px solid #02B959',
      },
      actionBtnBorder: {
        color: '#02B959',
        colorS: 'none',
        background: 'none',
        border: '1px solid #02B959',
        bili: '#02B959',
        colorBorder: '#02B959',
      },
      actionBtnBorderCol: {
        color: '#02B959',
        border: 'none',
      },
      tableBg: {
        color: '#323445',
        boxShadow: '6px 4px 44px rgba(0, 0, 0, 0.17)',
      },
      tableDis: {
        color: '#fff',
      },
      iconLabelBg: {
        color: '#292929',
      },
      iconLabelBgDisabled: {
        color: '#484a54',
      },
      iconLabelTextDisabled: {
        color: '#fff',
      },
      profileEditBg: {
        color: '#141414',
      },
      profileSectionSidebarContent: {
        color: '#2a2c39',
      },
      profileSectionSidebar: {
        color: '#1f1d2b',
      },
      backArrowBtn: {
        color: '#01051a',
      },
      headerBgColor: {
        color: '#1d1e28',
      },
      sidebarBtn: {
        color: '#6F6F6F',
      },
      mainLayout: {
        color: '#252735',
      },
      mainTableLayoutBg: {
        color: '#252525',
      },
      mainTableBorder: {
        color: '#242424',
      },
      tableBorderTransparent: {
        color: '#434667',
        bgColour: '#1E2132',
      },
      modalsContentBg: {
        color: '#252735',
        backgroundImage: `url(${userDivLight})`,
      },
      activeButton: {
        color: '#2e2e2e',
      },
      headerIcons: {
        color: '#353535',
      },
      platform: {
        color: '#1f1d2b',
      },
      counterBorder: {
        color: '#333743',
      },
      modalHeaderBg: {
        color: '#292929',
      },
      mainTableLayout: {
        color: '#252525',
      },
      avatarBg: {
        color: '#191919',
      },
      sidebarIconBg: {
        color: '#fff',
      },
      activeDropdown: {
        color: '#242424',
      },
      activeDropdownButton: {
        color: '#3e3e3e',
      },
      dropdownHover: {
        color: 'rgba(255, 255, 255, 0.08)',
      },
      headerBorder: {
        color: 'rgba(163,163,175,.35)',
      },
      sidebarBg: {
        background: '#2a2c39',
      },
      activeMenuBg: {
        color: 'rgba(255,255,255,.1)',
      },
      borderDark: {
        color: 'rgba(255, 255, 255, 0.11)',
      },
      tableTbodyBg: {
        color: '#323445',
        background: `url(${tableLink})`,
      },
      defaultBtnShadow: {
        boxShadow: '0 4px 10px rgb(0 0 0 / 50%)',
        background: '#3B3F59',
        backgroundHover: '#5e627b',
        color: '#202232',
        borderColor: '#32354B',
        filter: 'none',
      },
      loaderPrimary: {
        color: '#2a2c39',
      },
      loaderSecondary: {
        color: 'rgba(69,69,69,0.7)',
      },
      invert: {
        invert: 'invert(1)',
      },
      profileLogo: {
        color: '#2a2c39',
      },
    },
  },
};
